import { beschriftung, periodenname, t } from './sprache'
import type { Sprachschluessel } from './sprache'
import type { Lieferhinweis } from './typen'

/**
 * **Wer im Monat nichts geliefert hat — und was dafür dasteht**
 * (2.12 Abschnitt 3.20, R975, R978).
 *
 * Der Befund vom 2026-10-03: Die Tochter USA hatte nur den Juni geliefert,
 * der Stichtag stand auf Dezember, und drei der vier Spaltenbilder zeigten
 * eine leere Bilanz ohne ein Wort dazu. Seither trägt ein Monat ohne
 * Lieferung den letzten Bestand des Geschäftsjahres — und sagt es. Wo nichts
 * fortzuschreiben ist, sagt die leere Seite, warum sie leer ist.
 *
 * **Eine Stelle für alle Bilder:** Der Satz entsteht hier, für den Hinweis
 * über dem Bericht und für den Wertenachweis. Der Vermerk im Spaltenkopf des
 * Periodenbilds ist seit dem 2026-10-06 fort (R975, Entscheidung des
 * Auftraggebers: weglassen statt reparieren).
 */
export function liefersatz(hinweis: Lieferhinweis, periode: number): string {
  const werte = {
    gesellschaft: beschriftung(hinweis.namen),
    periode: periodenname(periode),
    aus: hinweis.aus ? periodenname(hinweis.aus) : '',
  }

  if (hinweis.art === 'fortgeschrieben') {
    return t('lieferstand.fortgeschrieben', werte)
  }

  // **Nicht fällig ist ein Vermerk, kein Befund** (2.12 Abschnitt 3.27, R1526).
  if (hinweis.art === 'nicht-faellig') {
    return t('lieferstand.nicht-faellig', {
      ...werte,
      rhythmus: t(`stammdaten.wert.rhythmus.${hinweis.rhythmus ?? 'monatlich'}` as Sprachschluessel),
    })
  }

  return hinweis.aus ? t('lieferstand.ohne', werte) : t('lieferstand.nie', werte)
}

/** Der Hinweis über dem Bericht — nur, wenn jemand nicht geliefert hat. */
export function Lieferstand({
  hinweise,
  periode,
}: {
  hinweise: Lieferhinweis[] | null | undefined
  periode: number
}) {
  if (!hinweise || hinweise.length === 0) {
    return null
  }

  return (
    <div className="hinweis lieferstand" role="note">
      {hinweise.map((h) => (
        <p key={h.einheit}>{liefersatz(h, periode)}</p>
      ))}
    </div>
  )
}
